import React from "react";
import { Email, Instagram, Linkedin, Web, XT } from "./svg.js";
import { motion } from "framer-motion";

function Footer() {
  return (
    <React.StrictMode>
          <motion.div
        initial={{
          display: "none",
        }}
        animate={{
          display: "flex",
        }}
        transition={{
          duration: 0.1,
        }}
        id="footer"
        className="xl:px-20 lg:px-12 md:px-8 sm:px-4 px-6 py-20 min-h-[80px] bg-gray-900 flex items-center mt-20"
      >
        <div className=" *:max-w-[280px] *:w-full py-12 px-8 max-w-[2560px] w-full mx-auto flex flex-wrap gap-8 justify-between content-center">
          <div className="">
            <a href={"/"} className="t-head la">
              METABRIX
            </a>

            <p className="text mt-4">
              ©2024 Metabrix Labs <br /> All rights reserved.
            </p>
          </div>
          <div className=" flex flex-col gap-2">
            <h1 className="t-head la">Contact Us</h1>
            <a
              href={"mailto:info@metabrixlab.com"}
              target="_blank"
              className="flex items-center gap-2"
            >
              <Email size={24} fill={"#fff"} />

              <p className=" text">info@metabrixlab.com</p>
            </a>
            <a
              href={"https://metabrixlab.com"}
              target="_blank"
              className="flex items-center gap-2"
            >
              <Web size={24} fill={"#fff"} />
              <p className=" text">www.metabrixlab.com</p>
            </a>
          </div>
          <div className=" flex flex-col gap-4">
            <h1 className="t-head la">Social Media</h1>

            <div className=" flex flex-wrap gap-4">
              <a href={"https://www.instagram.com/metabrix_labs/"}>
                <Instagram size={32} fill={"#fff"} />
              </a>
              <a
                href={
                  "https://www.linkedin.com/company/82097463/admin/dashboard/"
                }
              >
                <Linkedin size={32} fill={"#fff"} />
              </a>
              <a href={"https://x.com/metabrixlabs/"}>
                <XT size={32} fill={"#fff"} />
              </a>
            </div>
          </div>
        </div>
      </motion.div>
    </React.StrictMode>
  );
}

export default Footer;